
import { Component, Vue, Prop } from "vue-property-decorator";
import CourseItem from "./components/CourseItem.vue";
import { getCourseList } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo } from "@/utils/seo";
@Component({
  components: {
    CourseItem,
    Pagination,
    Breadcrumb
  }
})
export default class Course extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "公开课 | 光华赋能公开课程列表，涵盖战略、管理、营销、人力等领域 - 光华赋能",
      description:
        "光华赋能公开课列表，涵盖企业战略、经营管理、市场营销、人力资源、财务管理、生产运营等领域，定期开课，帮助企业管理者系统提升经营管理能力。",
      keywords:
        "公开课,企业培训课程,管理课程,战略管理,营销课程,人力课程,公开课程,光华赋能",
      path: "/course",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "光华商学院" },
        { name: "公开课" }
      ]
    });
  }

  total = 1;
  page = 1;
  tag = 0 as any;
  per_page = 12;
  list: any = [];
  index: any = 0;
  List = [
    { title: "光华商学院", url: "" },
    { title: "公开课", url: "" }
  ];
  ext_type = "" as any;
  items = [
    { type: "", label: "全部" },
    { type: "1", label: "光华公开课" },
    { type: "2", label: "近期活动" }
  ];
  created() {
    if (this.$route.query.tag) {
      this.tag = this.$route.query.tag;
    }
    this.initData();
    this.courseList();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.courseList();
  }
  async courseList() {
    const { data, total } = await getCourseList({
      ext_type: this.ext_type,
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;
    this.total = Number(total);
    // if (this.index > 0) {
    //   this.$nextTick(() => {
    //     window.location.hash = "#li" + this.index;
    //   });
    // }
  }
  clickCourse(item: any) {
    this.$router.push(`/course-detail?course_id=${item.course_id}`);
  }

  initData() {
    if (this.tag == 1) {
      this.ext_type = 1;
    } else if (this.tag == 2) {
      this.ext_type = 2;
    } else {
      this.ext_type = "";
    }
  }
  clickTag(index: any) {
    this.tag = index;
    this.initData();
    this.page = 1;
    this.courseList();
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
